export default __webpack_public_path__ + "static/media/kartu-2.9a97f15d.jpg";